const homeTopSlides = {
  slides: [{
    caption: 'All-Inclusive Vacations',
    link: '/turks-caicos/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/turks/TC_banner_new.jpg'
  }]
};

module.exports = homeTopSlides;
